import { uploadPhoto } from "@/api/UploadApi";
import Immobilie from "@/models/immobilie.model";
import CachedPhoto from "@/models/photo/cached-photo.model";
import { Monitoring } from "@/utilities/monitoring";
import { computed } from "vue";
import { useStore } from "@/composables/useTypedStore";

export default function useImmobilieHelper(immobilie: Immobilie) {

  const store = useStore();
  const currentProject = computed(() => store.state.user.currentUserProject);
  
  function getVerwalterLabel() {
    if (!immobilie?.verwalters || immobilie?.verwalters?.length === 0) return;
    return immobilie.verwalters[0].organisation;
  }

  async function uploadVorschaubild(
    photo: CachedPhoto,
    propertyId: any
  ) {
    const oldVorschaubildId = immobilie?.vorschaubild?.id;

    const result = await uploadPhoto(
      photo,
      "api::immobilie.immobilie",
      propertyId?.toString(),
      "vorschaubild",
      propertyId + Date.now().toString() + ".jpeg",
      "immobilie"
    );

    // fotoID auslesen
    const res = await Immobilie.api().post("/immobilie/addImmoPhoto?projectId=" + currentProject.value.id, {
      propertyId: propertyId?.toString(),
      imageId: result.data[0].id,
      oldVorschaubildId // needs to be send with the request because uploadPhoto already overwrites the info for the backend
    });
  }

  async function uploadImmoBilder(
    photos: CachedPhoto[],
    propertyId: any
  ) {
    Monitoring.consoleOnly("uploadImmoBilder start...");

    const results = await Promise.all(
      photos.map((el) => {
        return uploadPhoto(
          el,
          "api::immobilie.immobilie",
          propertyId?.toString(),
          "bilder",
          propertyId + Date.now().toString() + ".jpeg",
          "immobilie"
        );
      })
    );
  }

  return {
    getVerwalterLabel,
    uploadVorschaubild,
    uploadImmoBilder,
  };
}
